import { useOutletContext } from "react-router";
import type { WorkspaceLoaderData } from "@/routes/workspaceLoader";
import type { AuthenticatedUser } from "@/hooks/useAuthenticatedUser";

export interface WorkspaceOutletContext {
	projects: WorkspaceLoaderData["projects"];
	judges: WorkspaceLoaderData["judges"];
	codes: WorkspaceLoaderData["codes"];
	datasets: WorkspaceLoaderData["datasets"];
	profile: WorkspaceLoaderData["profile"];
	user: AuthenticatedUser;
	userIsAdmin: WorkspaceLoaderData["userIsAdmin"];
	refreshWorkspaceData: () => void;
	createProject: () => void;
	createJudge: () => void;
	createCode: () => void;
	createDataset: () => void;
}

export const useWorkspaceViewContext = () =>
	useOutletContext<WorkspaceOutletContext>();
